/* Treasure Collect – the homepage hero wall (sections/tc-hero-wall.liquid, styles in tc-hero-wall.css).
   Three rows slide sideways, to the left and to the right in turn: on large screens the middle one about twice as
   fast as the other two; on tablets and phones, where the words sit over it, the middle one at half their pace. The
   sliding is a set of endless browser animations of the translate property (one per display), so it runs on the
   compositor and stays smooth whatever else the page is doing; this script only reads where each display is from
   those animations.
   Every display comes into view as a drawing, its artwork in fine gold lines and only the card in colour. On arrival
   the displays in view light up quickly, one after another, so the wall is in colour at once (is-quick); after that
   one by one, when the light passes over them or by themselves a few seconds after they came into view. The colour
   blooms out of the card (is-lit; the styles do the rest), then the glass glitters for a moment (is-gold) and the
   word TREASURES catches the light (is-glint). A display stays lit until it leaves the view and comes back on the
   other side as a new drawing: another artwork, acrylic or PSA, keeping the two lines balanced (or only acrylic, when
   the section is set to show one line).
   On large screens the words start where the logo does, and the wall is seen at an angle from behind them, where its
   rows fade into the dark (the plane's ::after), to beyond the right edge, at any width: its length, perspective and
   roll are fitted to the screen and to where the words end, and on very wide screens the rows get more displays
   (copies of the section's own). On tablets and phones the wall is flat and runs on a diagonal, its middle row right
   behind the words (all in the styles). The light sweeps in on arrival, then follows the pointer, or wanders on its
   own path, which the browser itself moves (glide). With reduced motion the wall stands still, in colour. */
(function () {
  if (window.tcHeroWallLoaded) return;
  window.tcHeroWallLoaded = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var GAP = 0.14; // gap between the displays of a row, as a share of their width
  var GOLD_MS = 1200; // how long a display keeps is-gold
  var GOLD_MAX = 5; // at most this many gold moments at once
  var GLITTER_AFTER = 2.6; // seconds from lighting up to the glitter: the colour has reached the edges by then
  var QUICK_GLITTER_AFTER = 1.15; // the same for a display lit on arrival, whose colour comes in faster
  var WAVE_SECS = 1.8; // on arrival the displays in view light up one after another within about this long,
  var WAVE_UNTIL = 5; // and so does any display that comes into view in the first seconds
  var ROW_MAX = 32; // displays in a row at most, for the widest screens

  function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function smooth(x) { x = clamp01(x); return x * x * (3 - 2 * x); }
  function mod(a, n) { return ((a % n) + n) % n; }
  // how long a display stays a drawing once in view before it lights up by itself
  function waitTime(narrow) { return (narrow ? 2.5 : 3) + Math.random() * (narrow ? 4.5 : 6); }
  // displays per second: on large screens the middle row, the one seen best, runs about twice as fast as the other
  // two; on tablets and phones the words sit over it, so it runs at half the pace of the others
  function paceOf(r, middle, narrow) {
    if (narrow) return r === middle ? 0.09 : r < middle ? 0.2 : 0.22;
    return r === middle ? 0.24 : 0.115 + 0.01 * r;
  }

  // large screens: the wall is seen at an angle (the styles: perspective, rotateY -16deg, rotateX 5deg, a roll) and
  // turns round its right end, which stands a fifth of the hero's height beyond the screen. Its length is found so
  // that the rows come out of the dark (0.9 of a display's pitch along the wall) where the words end; the perspective
  // grows with the length and the roll shrinks with it, so a laptop and an ultra-wide screen see the same wall, only
  // longer. At 1440 x 900 this is about the plane the styles start from (12% in, 12% out, 1500px, -3deg).
  function fitWall(W, H, P, textR) {
    var originX = W + 0.2 * H, target = textR;
    var lo = Math.max(3 * P, 0.4 * W), hi = 3 * W + 4 * H, len = lo, p = 1500, rz = -3;
    function endAt(l) {
      p = 1.04 * l;
      rz = -3 * Math.min(1, 1.68 * H / l);
      var m = new DOMMatrix();
      m.m34 = -1 / p;
      m = m.rotate(0, -16, 0).rotate(5, 0, 0).rotate(0, 0, rz);
      var q = m.transformPoint(new DOMPoint(0.9 * P - l, 0, 0, 1));
      return originX + q.x / q.w;
    }
    for (var i = 0; i < 28; i++) {
      len = (lo + hi) / 2;
      if (endAt(len) > target) lo = len; else hi = len;
    }
    endAt(len);
    return { l: originX - len, r: W - originX, p: p, rz: rz };
  }

  function init(root) {
    if (!root || root.tcWall) return;
    var plane = root.querySelector('.tc-wall__plane');
    // without animations of the translate property the wall stays as it is drawn, still and in colour
    if (!plane || !plane.animate || !window.DOMMatrix || !window.DOMPoint || !(window.CSS && CSS.supports && CSS.supports('translate', '1px 0px'))) return;
    root.tcWall = true;
    // with reduced motion the wall stands still, in colour, but still fills the screen (is-still)
    var still = reduce.matches;
    if (still) {
      root.classList.remove('is-live', 'is-armed');
      root.classList.add('is-still');
    }

    // the header sits over the hero on the home page: leave room for it
    var header = document.getElementById('header');
    if (header) {
      var hh = header.offsetHeight;
      if (getComputedStyle(header).position === 'absolute' && hh > 20 && hh < 240) root.style.setProperty('--hdr', hh + 'px');
    }

    var light = root.querySelector('.tc-wall__light');
    var wall = root.querySelector('.tc-wall');
    var treasure = root.querySelector('.tc-hw__treasure');
    var words = [root.querySelector('.tc-hw__title'), root.querySelector('.tc-hw__sub')];
    // the slow shine on TREASURES and on the name under it: a bright copy of the word behind a sliding window (the
    // styles move both; nothing is repainted)
    if (!still) {
      [[treasure, treasure && treasure.querySelector('.tc-home-hero__gold')], [root.querySelector('.tc-hw__sub > span')]].forEach(function (pair) {
        var host = pair[0], word = pair[1] || pair[0];
        if (!host || !word || host.querySelector('.tc-hw__sheen')) return;
        var band = document.createElement('span'), copy = document.createElement('span');
        band.className = 'tc-hw__sheen';
        band.setAttribute('aria-hidden', 'true');
        copy.className = 'tc-hw__sheen-copy';
        copy.textContent = word.textContent;
        band.appendChild(copy);
        host.appendChild(band);
      });
    }
    // where the logo starts, so the words on large screens start there too
    var logo = header && (header.querySelector('.header__heading-logo') || header.querySelector('.header__heading-link'));
    // every artwork of both lines, so a display coming back into view can be a new one:
    // { a: [[slug, small, big, drawing small, drawing big]], p: [...] }
    var art = { a: [], p: [] };
    var artEl = root.querySelector('[data-tc-wall-art]');
    if (artEl) {
      try { art = JSON.parse(artEl.textContent); } catch (err) { art = { a: [], p: [] }; }
    }
    // a wall of one line only (the section's "Acrylic only"): there is nothing to balance, every display that comes
    // back or is added is of that line
    var only = !art.p.length ? 'a' : !art.a.length ? 'p' : '';

    // a display of the wall. Its colour picture gets two copies over it, which light it up (the styles: one held to
    // the light around the card, one whole); they share the picture, so nothing more is downloaded
    function tileOf(el) {
      var img = el.querySelector('.tc-wall__img');
      var bloom = el.querySelector('.tc-wall__bloom'), full = el.querySelector('.tc-wall__full');
      if (img && !bloom && !still) {
        bloom = img.cloneNode(false);
        bloom.className = 'tc-wall__bloom';
        full = img.cloneNode(false);
        full.className = 'tc-wall__full';
        img.parentNode.insertBefore(full, img.nextSibling);
        img.parentNode.insertBefore(bloom, full);
      }
      return { el: el, img: img, bloom: bloom, full: full, sketch: el.querySelector('.tc-wall__sketch'), kind: el.getAttribute('data-k'), slug: el.getAttribute('data-s'), copy: false, ready: false, quick: false, anim: null, lead: 0, cx: -1e4, cy: -1e4, on: false, open: false, latched: false, litT: 0, seenT: null, wait: 0, cycle: null, armed: true, goldUntil: 0 };
    }
    var allTiles = [];
    var rowEls = [].slice.call(plane.querySelectorAll('.tc-wall__row'));
    var middle = (rowEls.length - 1) / 2;
    var rows = rowEls.map(function (el, r) {
      var own = [].slice.call(el.querySelectorAll('.tc-wall__tile')).map(tileOf);
      allTiles = allTiles.concat(own);
      return { el: el, r: r, dir: r % 2 ? 1 : -1, phase: (r * 0.618) % 1, own: own.length, n: 0, P: 0, pace: 0, L: 0, D: 0, tiles: own };
    });

    var act = rows, tiles = allTiles, running = false, balanced = false;
    var W = 1, H = 1, P = 160, tw = 140, R0 = 120, R1 = 300, narrow = false, wallTop = 0, wallBottom = 1, openL = 0;
    // the wall's own angle, to find where a display is on screen without asking the page; where the wall sits in the
    // hero (wx, wy)
    var M = null, ox = 0, oy = 0, pl = 0, pt = 0, wx = 0, wy = 0;
    var t = 0;

    // where the words end, from the hero's left edge (their own text, not their boxes, nor the shine's window)
    function wordsRight() {
      var right = 0, left = root.getBoundingClientRect().left, range = document.createRange();
      words.forEach(function (el) {
        if (!el) return;
        var walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false), node;
        while ((node = walk.nextNode())) {
          if (!node.nodeValue.trim() || (node.parentNode.closest && node.parentNode.closest('.tc-hw__sheen'))) continue;
          range.selectNodeContents(node);
          var b = range.getBoundingClientRect();
          if (b.width) right = Math.max(right, b.right - left);
        }
      });
      return right || W * 0.48;
    }

    // a line for a display added at the end of a row: never three alike side by side, the two lines even
    function kindAfter(row, k) {
      var a = 0, p = 0;
      for (var q = 0; q < k; q++) { if (row.tiles[q].kind === 'a') a++; else p++; }
      var l1 = row.tiles[k - 1].kind, l2 = row.tiles[k - 2].kind;
      if (l1 === l2) return l1 === 'a' ? 'p' : 'a';
      if (a !== p) return a < p ? 'a' : 'p';
      return Math.random() < 0.5 ? 'a' : 'p';
    }
    function usedOn(row) {
      var used = {};
      row.tiles.forEach(function (o) { used[o.slug] = true; });
      return used;
    }

    // very wide screens: a row needs more displays than the section has, so it gets copies of its own, each made a
    // new display of its own
    function grow(row, count) {
      var made = false;
      while (row.tiles.length < count) {
        var k = row.tiles.length;
        var el = row.tiles[k % row.own].el.cloneNode(true);
        el.classList.remove('is-lit', 'is-quick', 'is-gold', 'is-in', 'is-reset');
        el.style.display = '';
        el.style.setProperty('--i', k);
        el.style.setProperty('--td', (250 + (k % 12) * 40 + row.r * 50) + 'ms');
        [].forEach.call(el.querySelectorAll('img'), function (im) { im.removeAttribute('loading'); });
        row.el.appendChild(el);
        var o = tileOf(el);
        o.copy = true;
        row.tiles.push(o);
        allTiles.push(o);
        if (art.a.length || art.p.length) dress(o, only || kindAfter(row, k), usedOn(row), [row.tiles[k - 1].slug, row.tiles[0].slug]);
        if (!still) arrive(o);
        made = true;
      }
      return made;
    }

    // geometry and the sliding animations; redone when the window changes size
    function layout() {
      W = root.offsetWidth || 1;
      H = root.offsetHeight || 1;
      narrow = W < 990;
      act = rows.filter(function (row) { return row.el.offsetHeight > 0; });
      var first = act.length ? act[0].tiles[0].el : null;
      tw = first ? first.offsetWidth : 140;
      var th = first ? first.offsetHeight : 230;
      P = tw * (1 + GAP);
      // the wave of colour and its gold ring are sized from the displays' width
      plane.style.setProperty('--tw', tw.toFixed(2) + 'px');
      if (!narrow) {
        // the words start where the logo does
        if (logo) {
          var lx0 = logo.getBoundingClientRect().left - root.getBoundingClientRect().left;
          if (lx0 > 0 && lx0 < W / 3) root.style.setProperty('--logo-x', lx0.toFixed(1) + 'px');
        }
        // the wall from behind the words to beyond the right edge, and the dark behind the words
        var textR = wordsRight();
        root.style.setProperty('--text-r', textR.toFixed(1) + 'px');
        var fit = fitWall(W, H, P, textR);
        plane.style.setProperty('--fit-l', fit.l.toFixed(1) + 'px');
        plane.style.setProperty('--fit-r', fit.r.toFixed(1) + 'px');
        plane.style.setProperty('--fit-p', fit.p.toFixed(1) + 'px');
        plane.style.setProperty('--fit-rz', fit.rz.toFixed(3) + 'deg');
        // the dark the rows fade into, from beyond where they end to about a display into the wall
        plane.style.setProperty('--fade-l', (-2 * P).toFixed(1) + 'px');
        plane.style.setProperty('--fade-w', (2.9 * P).toFixed(1) + 'px');
        plane.style.setProperty('--fade-solid', (P + tw + 0.1 * P).toFixed(1) + 'px');
        // displays count as in view from where the words end
        openL = Math.max(0, textR - 0.15 * P);
      }
      var need = Math.min(ROW_MAX, Math.ceil(plane.offsetWidth / P) + 2);
      var grew = false, rebuilt = false;
      act.forEach(function (row) { if (grow(row, need)) grew = true; });
      tiles = [];
      act.forEach(function (row) {
        var n = Math.min(row.tiles.length, need);
        var pace = paceOf(row.r, middle, narrow);
        row.y = row.el.offsetTop + th / 2;
        tiles = tiles.concat(row.tiles.slice(0, n));
        // the same row as before (a phone's address bar came or went): it keeps running untouched
        if (n === row.n && Math.abs(P - row.P) < 0.05 && pace === row.pace) return;
        // a new size or pace: the row starts again from where it is now, so nothing jumps
        if (row.D && row.tiles[0].anim) row.phase = mod(row.phase + row.dir * (row.tiles[0].anim.currentTime || 0) / row.D, 1);
        rebuilt = true;
        row.n = n;
        row.P = P;
        row.pace = pace;
        row.L = n * P;
        row.D = (n / pace) * 1000;
        row.tiles.forEach(function (o, k) {
          if (o.anim) { o.anim.cancel(); o.anim = null; }
          o.el.style.display = k < n ? '' : 'none';
          o.cycle = null;
          if (k >= n || still) return;
          // each display runs from one end of the row to the other and starts again, evenly spaced along the row.
          // It moves by its translate property, so its lit step forward (transform) stays its own
          var phi = mod(k / n + row.phase, 1);
          o.lead = row.dir > 0 ? phi : 1 - phi;
          o.anim = o.el.animate(
            [{ translate: (-P).toFixed(2) + 'px 0px' }, { translate: (row.L - P).toFixed(2) + 'px 0px' }],
            { duration: row.D, iterations: Infinity, easing: 'linear', direction: row.dir > 0 ? 'normal' : 'reverse', delay: -o.lead * row.D }
          );
          if (!running) o.anim.pause();
        });
      });
      var cs = getComputedStyle(plane);
      M = cs.transform && cs.transform !== 'none' ? new DOMMatrix(cs.transform) : new DOMMatrix();
      var origin = cs.transformOrigin.split(' ');
      ox = parseFloat(origin[0]) || 0;
      oy = parseFloat(origin[1]) || 0;
      wx = wall ? wall.offsetLeft : 0;
      wy = wall ? wall.offsetTop : 0;
      pl = plane.offsetLeft + wx;
      pt = plane.offsetTop + wy;
      R0 = Math.max(110, Math.min(W, H) * (narrow ? 0.24 : 0.25));
      R1 = R0 * 1.9;
      if (light) {
        var size = Math.round(R1 * 2.6);
        light.style.width = light.style.height = size + 'px';
        light.half = size / 2;
      }
      // on tablets and phones the light keeps to the wall, under the header
      wallTop = narrow ? Math.max(wy, parseFloat(getComputedStyle(root).getPropertyValue('--hdr')) || 72) : 0;
      wallBottom = narrow && wall ? wy + wall.offsetHeight : H;
      // the light's path follows the new size
      if (mode === 'glide') glide();
      if (still) return;
      // the rows were laid out again in the first moments (the words' own font came in and the wall was fitted
      // anew): the displays are not seen yet, so they are evened out again for where they now are
      if (balanced && rebuilt && t < 0.5) { evenOut(false); balanceStart(); }
      else if (grew) evenOut(true);
    }

    // the light: where it is (lx, ly), where it is going (tx, ty), how strong it is (power)
    var last = 0, raf = 0, inView = true;
    var mode = 'wait', modeT = 0, power = 0;
    var lx = 0, ly = 0, px = 0, py = 0, pointerT = -1e9, glintT = -10, autoT = 0, powerShown = -1, waveGap = 0, sx0 = 0, sy0 = 0;

    // the light's own path: a slow figure that comes back to its start every PATH_S seconds (both its swings fit in
    // that time), so it can be handed to the browser as one endless animation (glide)
    var PATH_S = 40, SWING_X = 2 * Math.PI / 20, SWING_Y = 2 * Math.PI * 3 / PATH_S;
    function wander(time) {
      if (narrow) {
        var mid = (wallTop + wallBottom) / 2, span = Math.max(40, (wallBottom - wallTop) * 0.32);
        return [W * 0.5 + W * 0.34 * Math.sin(time * SWING_X + 0.9), mid + span * Math.sin(time * SWING_Y + 0.3)];
      }
      // over the wall, from where the words end to the right edge; a very long wall is crossed at half the pace
      var c = (openL + W) / 2, a = (W - openL) * 0.42, sx = a > 600 ? SWING_X / 2 : SWING_X;
      return [c + a * Math.sin(time * sx + 0.9), H * 0.5 + H * 0.3 * Math.sin(time * SWING_Y + 0.3)];
    }

    // the light on its path, moved by the browser itself (the graphics card), so this script writes nothing for it
    // frame by frame. It is taken back while the light follows the pointer, and handed over again once back on its
    // path. wt is where on its path the light is, in seconds
    var lightAnim = null, wt = 0;
    function glide() {
      if (!light || !light.animate) return false;
      var keys = [];
      for (var i = 0; i <= 160; i++) {
        var q = wander(PATH_S * i / 160);
        keys.push({ transform: 'translate3d(' + (q[0] - light.half - wx).toFixed(1) + 'px,' + (q[1] - light.half - wy).toFixed(1) + 'px,0)' });
      }
      if (lightAnim) lightAnim.cancel();
      lightAnim = light.animate(keys, { duration: PATH_S * 1000, iterations: Infinity, easing: 'linear' });
      lightAnim.currentTime = (wt % PATH_S) * 1000;
      if (!running) lightAnim.pause();
      return true;
    }
    function unglide() {
      if (!lightAnim) return;
      wt = (lightAnim.currentTime || 0) / 1000;
      lightAnim.cancel();
      lightAnim = null;
    }

    // a display lights up: the colour blooms out of its card (the styles); the glitter comes later. In the first
    // seconds it lights up faster (is-quick), and only one display in three glitters, so the arrival stays calm
    var waveLit = 0;
    function lightUp(o) {
      if (o.latched) return;
      o.latched = true;
      o.litT = t;
      o.quick = t < WAVE_UNTIL;
      if (o.quick) {
        o.armed = waveLit++ % 3 === 0;
        o.el.classList.add('is-quick');
      }
      o.el.classList.add('is-lit');
    }

    // a display has completed: a touch of gold on it, and TREASURES catches the light (not too often)
    function goldMoment(o) {
      var busy = 0;
      for (var q = 0; q < tiles.length; q++) if (tiles[q].goldUntil > t) busy++;
      if (busy >= GOLD_MAX) return;
      o.goldUntil = t + GOLD_MS / 1000;
      o.el.classList.remove('is-gold');
      void o.el.offsetWidth;
      o.el.classList.add('is-gold');
      setTimeout(function () { o.el.classList.remove('is-gold'); }, GOLD_MS);
      if (treasure && t - glintT > 2.2) {
        glintT = t;
        treasure.classList.remove('is-glint');
        void treasure.offsetWidth;
        treasure.classList.add('is-glint');
        setTimeout(function () { treasure.classList.remove('is-glint'); }, 950);
      }
    }

    // the line for a display on its way into view: never three alike side by side; otherwise the line there are
    // fewer of among the displays it comes into view with (those ahead of it in its row, as many as the row shows)
    // and in view on the whole wall; when both lines are even it is left to chance. Only the displays ahead count:
    // those behind it will come round as new displays themselves before they are seen beside it
    function lineFor(row, j) {
      var o = row.tiles[j], shown = 0;
      for (var q = 0; q < row.n; q++) if (row.tiles[q] !== o && row.tiles[q].open) shown++;
      function near(step) { return row.tiles[mod(j + step, row.n)].kind; }
      var ahead = row.dir > 0 ? 1 : -1, winA = 0, winP = 0, allA = 0, allP = 0;
      var out = {};
      if (near(ahead) === near(2 * ahead)) out[near(ahead)] = true;
      for (var s = 1; s < Math.max(3, shown); s++) { if (near(ahead * s) === 'a') winA++; else winP++; }
      for (var w = 0; w < tiles.length; w++) {
        if (tiles[w] === o || !tiles[w].open) continue;
        if (tiles[w].kind === 'a') allA++; else allP++;
      }
      // the row first (a row is seen as a line of displays), then the whole wall
      if (out.a && !out.p) return 'p';
      if (out.p && !out.a) return 'a';
      if (winA !== winP) return winA > winP ? 'p' : 'a';
      if (Math.abs(allA - allP) >= 2) return allA > allP ? 'p' : 'a';
      return Math.random() < 0.5 ? 'a' : 'p';
    }

    // a display has left the view and comes back on the other side: as a drawing again, and as a new display, of
    // the line that keeps what is seen balanced and with an artwork not already on that row
    function renew(row, o, j) {
      o.latched = false;
      o.quick = false;
      o.armed = true;
      o.seenT = null;
      o.goldUntil = 0;
      // back to its drawing at once, while out of view
      o.el.classList.add('is-reset');
      o.el.classList.remove('is-lit', 'is-quick', 'is-gold');
      void o.el.offsetWidth;
      o.el.classList.remove('is-reset');
      if (!art.a.length && !art.p.length) return;
      var used = {};
      for (var q = 0; q < row.n; q++) if (row.tiles[q] !== o) used[row.tiles[q].slug] = true;
      dress(o, only || lineFor(row, j), used, [row.tiles[mod(j - 1, row.n)].slug, row.tiles[mod(j + 1, row.n)].slug]);
    }

    // give a display a line and an artwork of that line that is not already on its row; when the row is longer than
    // the line has artworks (wide screens, one line only), at least not the artwork of a display beside it (near). The
    // pictures are decoded while the display is still out of view, so it never stutters on the way in
    function dress(o, kind, used, near) {
      var pool = art[kind].filter(function (x) { return !used[x[0]] && x[0] !== o.slug; });
      if (!pool.length && near) pool = art[kind].filter(function (x) { return near.indexOf(x[0]) < 0 && x[0] !== o.slug; });
      if (!pool.length) pool = art[kind];
      var pick = pool[Math.floor(Math.random() * pool.length)];
      o.kind = kind;
      o.slug = pick[0];
      o.el.setAttribute('data-k', kind);
      o.el.setAttribute('data-s', pick[0]);
      [o.img, o.bloom, o.full].forEach(function (im) {
        if (!im) return;
        im.srcset = pick[1] + ' 180w, ' + pick[2] + ' 340w';
        im.src = pick[1];
      });
      if (o.img && o.img.decode) o.img.decode().catch(function () {});
      if (o.sketch && pick[3]) {
        o.sketch.srcset = pick[3] + ' 180w, ' + pick[4] + ' 340w';
        o.sketch.src = pick[3];
        if (o.sketch.decode) o.sketch.decode().catch(function () {});
      }
    }

    // where a row is shorter than its pattern, or longer, three alike may meet where the row loops round or where
    // copies were added: the middle one changes line (before anything shows; later only among the copies)
    function evenOut(copiesOnly) {
      if (!art.a.length || !art.p.length) return;
      act.forEach(function (row) {
        var n = Math.min(row.tiles.length, row.n || row.tiles.length);
        for (var pass = 0; pass < 3; pass++) {
          var changed = false;
          for (var k = 0; k < n; k++) {
            var a = row.tiles[mod(k - 1, n)].kind, b = row.tiles[k].kind, c = row.tiles[mod(k + 1, n)].kind;
            if (a === b && b === c && (!copiesOnly || row.tiles[k].copy)) {
              dress(row.tiles[k], b === 'a' ? 'p' : 'a', usedOn(row));
              changed = true;
            }
          }
          if (!changed) break;
        }
      });
    }

    // before anything shows: the section's patterns are even over twelve displays, not over the few each row shows,
    // so what is seen is evened out too. First the displays in view, on each row and on the whole wall: one of the
    // line there are more of becomes the other line, where that makes no three alike. Then those on their way in,
    // in the order they will come, each given its line as it would be when coming back round (lineFor)
    function balanceStart() {
      if (!art.a.length || !art.p.length) return;
      var xs = act.map(function (row) {
        return row.tiles.slice(0, row.n).map(function (o) {
          // where it is now, as in frame(): a display with a lead of 1 is at the start of its next run
          var p0 = o.lead - Math.floor(o.lead);
          var x = (row.dir > 0 ? p0 : 1 - p0) * row.L - P + tw / 2 - ox, y = row.y - oy;
          return (M.m11 * x + M.m21 * y + M.m41) / (M.m14 * x + M.m24 * y + M.m44) + ox + pl;
        });
      });
      var from = narrow ? 0 : openL;
      var seen = act.map(function (row, c) {
        var ks = [];
        for (var k = 0; k < row.n; k++) {
          row.tiles[k].open = xs[c][k] > from && xs[c][k] < W;
          if (row.tiles[k].open) ks.push(k);
        }
        return ks;
      });
      function lean(c) {
        var d = 0;
        seen[c].forEach(function (k) { d += act[c].tiles[k].kind === 'a' ? 1 : -1; });
        return d;
      }
      for (var step = 0; step < 8; step++) {
        var leans = act.map(function (row, c) { return lean(c); });
        var total = leans.reduce(function (s, d) { return s + d; }, 0);
        // the row furthest off, or, when every row is close, the one leaning the way the whole wall does
        var pick = -1, worst = 1;
        leans.forEach(function (d, c) { if (Math.abs(d) > worst) { worst = Math.abs(d); pick = c; } });
        if (pick < 0 && Math.abs(total) >= 2) leans.forEach(function (d, c) { if (pick < 0 && d * total > 0) pick = c; });
        if (pick < 0) break;
        var row = act[pick], more = leans[pick] > 0 ? 'a' : 'p', less = more === 'a' ? 'p' : 'a', done = false;
        for (var i = 0; i < seen[pick].length && !done; i++) {
          var k = seen[pick][i];
          if (row.tiles[k].kind !== more) continue;
          var b1 = row.tiles[mod(k - 1, row.n)].kind, b2 = row.tiles[mod(k - 2, row.n)].kind;
          var a1 = row.tiles[mod(k + 1, row.n)].kind, a2 = row.tiles[mod(k + 2, row.n)].kind;
          if ((b1 === less && b2 === less) || (a1 === less && a2 === less) || (b1 === less && a1 === less)) continue;
          dress(row.tiles[k], less, usedOn(row));
          done = true;
        }
        if (!done) break;
      }
      act.forEach(function (row, c) {
        // on its way in: before the view when the row runs right, beyond it when it runs left; nearest first
        var coming = [];
        for (var k = 0; k < row.n; k++) {
          if (row.tiles[k].open) continue;
          if ((row.dir > 0) === (xs[c][k] <= from)) coming.push(k);
        }
        coming.sort(function (k1, k2) { return row.dir > 0 ? xs[c][k2] - xs[c][k1] : xs[c][k1] - xs[c][k2]; });
        coming.forEach(function (k) {
          var kind = lineFor(row, k);
          if (kind !== row.tiles[k].kind) dress(row.tiles[k], kind, usedOn(row));
        });
      });
    }

    // a display fades in once both its pictures are in
    function arrive(o) {
      var waiting = 0;
      function ready() { if (--waiting <= 0) { o.ready = true; o.el.classList.add('is-in'); } }
      [o.sketch, o.img].forEach(function (im) {
        if (!im || (im.complete && im.naturalWidth)) return;
        waiting++;
        im.addEventListener('load', ready, { once: true });
        im.addEventListener('error', ready, { once: true });
      });
      if (!waiting) { o.ready = true; o.el.classList.add('is-in'); }
    }

    var resizeTimer = 0;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layout, 150);
    }

    layout();
    // the words' own font can change their size, and the logo can move when the header's own pictures arrive
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    window.addEventListener('load', layout, { once: true });
    window.addEventListener('resize', onResize);
    if (still) return;

    lx = W * 1.15;
    ly = H * 0.32;

    function frame(now) {
      if (!running) return;
      // while the browser moves the light, the rest (where the displays are, which light up) needs a look only
      // about 30 times a second
      if (mode === 'glide' && now - last < 30) {
        raf = requestAnimationFrame(frame);
        return;
      }
      var dt = Math.min(0.05, (now - last) / 1000 || 0.016);
      last = now;
      t += dt;

      // 1. where every display is: read from its own animation and carried through the wall's angle
      for (var c = 0; c < act.length; c++) {
        var row = act[c];
        for (var j = 0; j < row.n; j++) {
          var o0 = row.tiles[j];
          if (!o0.anim) continue;
          var ct = o0.anim.currentTime;
          if (ct === null) continue;
          var lap = ct / row.D + o0.lead;
          var cycle = Math.floor(lap);
          var p = lap - cycle;
          if (o0.cycle !== null && cycle !== o0.cycle) renew(row, o0, j);
          o0.cycle = cycle;
          var x = (row.dir > 0 ? p : 1 - p) * row.L - P + tw / 2 - ox;
          var y = row.y - oy;
          var wv = M.m14 * x + M.m24 * y + M.m44;
          o0.cx = (M.m11 * x + M.m21 * y + M.m41) / wv + ox + pl;
          o0.cy = (M.m12 * x + M.m22 * y + M.m42) / wv + oy + pt;
          o0.on = o0.cx > -tw && o0.cx < W + tw && o0.cy > -tw && o0.cy < H + tw;
          o0.open = o0.on && (narrow ? o0.cy > wallTop && o0.cy < wallBottom && o0.cx > 0 && o0.cx < W : o0.cx > openL && o0.cx < W && o0.cy > H * 0.04 && o0.cy < H * 0.96);
          if (o0.open && o0.seenT === null) {
            o0.seenT = t;
            o0.wait = waitTime(narrow);
          }
        }
      }

      // 2. the light: on its path the browser moves it (glide) and only its place is worked out here; sweeping in on
      //    arrival, following the pointer, or easing back onto its path, this script moves it
      if (mode === 'glide') {
        wt = (lightAnim.currentTime || 0) / 1000;
        var g = wander(wt);
        lx = g[0]; ly = g[1];
      } else if (mode !== 'wait') {
        wt += dt;
        var on = wander(wt);
        if (mode === 'intro' || mode === 'back') {
          // from where it was to its path, which it joins exactly, so the hand-over shows nothing
          var k = smooth((t - modeT) / (mode === 'intro' ? 2.4 : 1.6));
          lx = sx0 + (on[0] - sx0) * k;
          ly = sy0 + (on[1] - sy0) * k;
          power = Math.min(1, power + dt * 1.8);
          if (k >= 1 && power >= 1 && glide()) mode = 'glide';
        } else if (mode === 'pointer') {
          var e = 1 - Math.exp(-dt / 0.08);
          lx += (px - lx) * e;
          ly += (py - ly) * e;
          power = Math.min(1, power + dt * 3);
          if (t - pointerT > 2.6) { mode = 'back'; modeT = t; sx0 = lx; sy0 = ly; }
        }
        if (light && mode !== 'glide') light.style.transform = 'translate3d(' + (lx - light.half - wx).toFixed(1) + 'px,' + (ly - light.half - wy).toFixed(1) + 'px,0)';
      }
      // its strength is written only while it changes
      if (light && power !== powerShown) {
        powerShown = power;
        light.style.opacity = power.toFixed(3);
      }

      // 3. on arrival the displays in view (their pictures in) light up quickly, one after another: from the right
      //    on large screens, where the light comes in, in no order on small ones. After that, a display that has
      //    been in view as a drawing for long enough lights up by itself, one at a time
      if (mode !== 'wait' && t < WAVE_UNTIL) {
        if (waveGap === 0) {
          var shown = 0;
          for (var s = 0; s < tiles.length; s++) if (tiles[s].open) shown++;
          waveGap = Math.min(0.16, Math.max(0.045, WAVE_SECS / Math.max(1, shown)));
        }
        if (t - autoT > waveGap) {
          var ready = [];
          for (var m = 0; m < tiles.length; m++) {
            if (tiles[m].open && !tiles[m].latched && tiles[m].ready) ready.push(tiles[m]);
          }
          if (ready.length) {
            var next = ready[0];
            if (narrow) next = ready[Math.floor(Math.random() * ready.length)];
            else ready.forEach(function (c2) { if (c2.cx > next.cx) next = c2; });
            lightUp(next);
            autoT = t;
          }
        }
      } else if (mode !== 'wait' && t - autoT > (narrow ? 0.55 : 0.4)) {
        var due = null, late = 0;
        for (var m2 = 0; m2 < tiles.length; m2++) {
          var cand = tiles[m2];
          if (!cand.open || cand.latched || cand.seenT === null) continue;
          var over = t - cand.seenT - cand.wait;
          if (over > late) { late = over; due = cand; }
        }
        if (due) { lightUp(due); autoT = t; }
      }

      // 4. the light lights up the displays it reaches. Each display glitters once, when its colour has spread
      for (var n = 0; n < tiles.length; n++) {
        var o = tiles[n];
        if (!o.latched && o.on) {
          var d = Math.sqrt((o.cx - lx) * (o.cx - lx) + (o.cy - ly) * (o.cy - ly));
          if (power * (1 - smooth((d - R0) / (R1 - R0))) > 0.75) lightUp(o);
        }
        if (o.armed && o.latched && t - o.litT > (o.quick ? QUICK_GLITTER_AFTER : GLITTER_AFTER)) {
          o.armed = false;
          if (o.on) goldMoment(o);
        }
      }

      raf = requestAnimationFrame(frame);
    }

    function run() {
      if (running || !inView || document.hidden) return;
      running = true;
      tiles.forEach(function (o) { if (o.anim) o.anim.play(); });
      if (lightAnim) lightAnim.play();
      last = performance.now();
      raf = requestAnimationFrame(frame);
    }
    function halt() {
      running = false;
      cancelAnimationFrame(raf);
      tiles.forEach(function (o) { if (o.anim) o.anim.pause(); });
      if (lightAnim) lightAnim.pause();
    }

    // the arrival: the words now, each display as soon as both its pictures are in, then the light sweeps in. Where
    // the words end decides where the wall starts, so their own font is waited for first, a moment at most
    var started = false;
    function start() {
      if (started) return;
      started = true;
      evenOut(false);
      balanceStart();
      balanced = true;
      root.classList.add('is-playing');
      root.classList.remove('is-armed');
      allTiles.forEach(function (o) { if (!o.copy) arrive(o); });
      setTimeout(function () { if (mode === 'wait') { mode = 'intro'; modeT = t; sx0 = W * 1.12; sy0 = narrow ? (wallTop + wallBottom) / 2 : H * 0.3; } }, 250);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          if (inView) run(); else halt();
        }).observe(root);
      }
      document.addEventListener('visibilitychange', function () { if (document.hidden) halt(); else run(); });
      run();
    }
    if (document.fonts && document.fonts.status === 'loading') {
      document.fonts.ready.then(start);
      setTimeout(start, 600);
    } else start();

    root.addEventListener('pointermove', function (ev) {
      var r = root.getBoundingClientRect();
      px = ev.clientX - r.left;
      py = ev.clientY - r.top;
      pointerT = t;
      if (mode !== 'wait') { unglide(); mode = 'pointer'; }
    }, { passive: true });
    root.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType === 'mouse') return;
      var r = root.getBoundingClientRect();
      px = ev.clientX - r.left;
      py = ev.clientY - r.top;
      pointerT = t;
      if (mode !== 'wait') { unglide(); mode = 'pointer'; }
    }, { passive: true });
    root.addEventListener('pointerleave', function () { pointerT = t - 2; });
  }

  function scan() {
    [].forEach.call(document.querySelectorAll('[data-tc-wall]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
